module.exports = __webpack_public_path__ + "img/panel5.ace73644.jpg";